import { render, staticRenderFns } from "./StagingAuthorsForm.vue?vue&type=template&id=6c7d5c10"
import script from "./StagingAuthorsForm.vue?vue&type=script&lang=ts"
export * from "./StagingAuthorsForm.vue?vue&type=script&lang=ts"
import style0 from "./StagingAuthorsForm.vue?vue&type=style&index=0&id=6c7d5c10&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports